module.exports = __webpack_public_path__ + "img/eletroduto1.ee0b04f7.png";